import { useRef } from 'react';
import { Button } from '@/shared/components/ui/button';

const RedirectNotification = () => {
  const notification = useRef();

  return (
    <div ref={notification} className="redirect-notification-container">
      <div className="$tw-z-50 $tw-flex $tw-max-w-2xl $tw-items-center $tw-rounded-md $tw-bg-slate-50 $tw-p-4 $tw-shadow-md $tw-transition-all">
        <div>
          <p className="$tw-m-0">
            Te hemos redirigido al acceso directo de la plataforma Smart Charging.
          </p>
          <p className="$tw-m-0">
            Si en el futuro quieres ahorrarte este paso, puedes ingresar directamente a{' '}
            <a href={window.location.host}>{window.location.host}</a> con tu email.
          </p>
        </div>
        <Button
          type="button"
          onClick={() => {
            notification.current.classList.add('hidden');
          }}
        >
          Aceptar
        </Button>
      </div>
    </div>
  );
};

export default RedirectNotification;
